import { CheckCircle } from "lucide-react";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "~/components/ui/button";

interface FtueUploadSuccessProps {
  titleId: string;
  titleDefault: string;
  subtitleId: string;
  subtitleDefault: string;
  onContinue: () => void;
}

export const FtueUploadSuccess: FC<FtueUploadSuccessProps> = ({
  titleId,
  titleDefault,
  subtitleId,
  subtitleDefault,
  onContinue,
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] px-4">
      <div className="max-w-xl w-full text-center space-y-8">
        <div className="mx-auto w-20 h-20 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-green-600 dark:text-green-400" />
        </div>

        <div className="space-y-3">
          <h1 className="text-3xl font-semibold text-foreground">
            <FormattedMessage id={titleId} defaultMessage={titleDefault} />
          </h1>
          <p className="text-lg text-muted-foreground">
            <FormattedMessage
              id={subtitleId}
              defaultMessage={subtitleDefault}
            />
          </p>
        </div>

        <Button size="lg" onClick={onContinue} className="px-8">
          <FormattedMessage
            id="ftue.success.continue"
            defaultMessage="Continue"
          />
        </Button>
      </div>
    </div>
  );
};
